import { E_GatewayDataFormat, E_GatewayDHCPModel, E_GatewayOnLineStatus, E_GatewayTranslateProtocol, E_LoraBandwidth, E_LoraLowSpeedOpt, E_OfflineDataStatus, E_SensorRegisterStatus } from '@/api/moudules/gateway.types'
import { E_TimeUnit, toSeconds } from '@/utils/time'
import _ from 'lodash'
import Vue from 'vue'

/**
 * $t('enum.E_WirelessFrequency.H_2450MHz')
 */
export enum E_WirelessFrequency {
    H_2450MHz = 0,
}


export const WirelessFrequencyOptions = [E_WirelessFrequency.H_2450MHz]
export const WirelessChannelOptions = _.range(0, 20 + 1)


export const GatewayOnLineStatusOptions = Object.freeze([
    E_GatewayOnLineStatus.Online,
    E_GatewayOnLineStatus.Offline,
])

export const GatewayTranslateProtocolOptions = Object.freeze([
    E_GatewayTranslateProtocol.TCP,
    E_GatewayTranslateProtocol.MQTT,
    E_GatewayTranslateProtocol.ModbusTCP,
    E_GatewayTranslateProtocol.ModbusRTU,
])

export const GatewayDataFormatOptions = Object.freeze([
    E_GatewayDataFormat.Raw,
    E_GatewayDataFormat.Json,
])

export const GatewayHeartbeatOptions = ($t) => {
    return [
        { label: $t('gateway.heartbeatNoSleep'), value: 0 },
        { label: $t('gateway.heartbeat30s'), value: 30 },
        ...[1, 5, 10, 15, 30].map(value => {
            return { label: $t('gateway.heartbeatMinutes', { value }), value: toSeconds(value, E_TimeUnit.Minute) }
        }),
        ..._.range(1, 25).map(value => {
            return { label: $t('gateway.heartbeatHours', { value }), value: toSeconds(value, E_TimeUnit.Hour) }
        })
    ]
}

export const GatewayDHCPModelOptions = Object.freeze([
    E_GatewayDHCPModel.DHCP,
    E_GatewayDHCPModel.Static,
])

export const LoraLowSpeedOptOptions = Object.freeze([
    E_LoraLowSpeedOpt.Default,
    E_LoraLowSpeedOpt.Open,
    E_LoraLowSpeedOpt.Close,
])

export const LoraBandwidthOptions = Object.freeze([
    E_LoraBandwidth.Hz_125KHz,
    E_LoraBandwidth.Hz_250KHz,
    E_LoraBandwidth.Hz_500KHz,
])

export const SensorRegisterStatusOptions = Object.freeze([
    E_SensorRegisterStatus.Allow,
    E_SensorRegisterStatus.DisAllow,
])

export const OfflineDataStatusOptions = Object.freeze([
    E_OfflineDataStatus.Allow,
    E_OfflineDataStatus.DisAllow,
])